import React from 'react';
import LudusBrandVisuals from '../components/LudusBrandVisuals';

const BGLPage = () => {
  return <LudusBrandVisuals />;
};

export default BGLPage;


